import React from "react"

function TagGroup(props) {
  return <div className="tags">{props.children}</div>
}

export default TagGroup
